import api from '../utils/api'
// 重用現有的 store API
import {
  getCategories,
  createCategory,
  getProducts,
  getProduct,
  createProduct,
  updateProduct,
  getStoreStats
} from './store'

// ==================== 重用現有 API ====================
// 以下 API 直接使用現有的 store API，無需後端額外開發

// 商品分類相關API - 重用現有 API
export const getInventoryCategories = () => {
  return getCategories()
}

export const createInventoryCategory = (data) => {
  return createCategory(data)
}

// 商品相關API - 重用現有 API
export const getInventoryProducts = (params) => {
  return getProducts(params)
}

export const getInventoryProduct = (id) => {
  return getProduct(id)
}

export const createInventoryProduct = (data) => {
  return createProduct(data)
}

export const updateInventoryProduct = (id, data) => {
  return updateProduct(id, data)
}

// 統計相關API - 重用現有 API
export const getInventoryStatistics = () => {
  return getStoreStats()
}

// ==================== 需要後端補充的 API ====================
// 以下 API 需要後端根據庫存管理需求進行擴充或新增

// 更新分類（需要後端補充）
export const updateInventoryCategory = (categoryId, data) => {
  return api({
    url: `/api/store/categories/${categoryId}`,
    method: 'put',
    data
  })
}

// 刪除分類（需要後端補充）
export const deleteInventoryCategory = (categoryId) => {
  return api({
    url: `/api/store/categories/${categoryId}`,
    method: 'delete'
  })
}

// 刪除商品（需要後端補充）
export const deleteInventoryProduct = (productId) => {
  return api({
    url: `/api/store/products/${productId}`,
    method: 'delete'
  })
}

// 更新商品庫存（需要後端補充）
export const updateInventoryProductStock = (productId, data) => {
  return api({
    url: `/api/store/products/${productId}/stock`,
    method: 'patch',
    data
  })
}

// ==================== 庫存管理專用 API（需要後端新增）====================
// 以下 API 是庫存管理模組專用的，需要後端新增實現

// 庫存使用記錄相關API（需要後端新增）
export const getInventoryUsage = (params) => {
  return api({
    url: `/api/store/inventory/usage`,
    method: 'get',
    params
  })
}

export const getInventoryUsageDetail = (usageId) => {
  return api({
    url: `/api/store/inventory/usage/${usageId}`,
    method: 'get'
  })
}

export const createInventoryUsage = (data) => {
  return api({
    url: `/api/store/inventory/usage`,
    method: 'post',
    data
  })
}

export const cancelInventoryUsage = (usageId, data) => {
  return api({
    url: `/api/store/inventory/usage/${usageId}/cancel`,
    method: 'post',
    data
  })
}

// 結帳 UI 用：給定一組服務 ID，取得這些服務搭配的耗材清單（含當前庫存商品狀態）。
// 回傳 { items: [{ serviceId, serviceName, productId, productName, quantity,
//   defaultCountAsSales, currentPrice, currentSuggestedPrice, currentCost,
//   currentStock, isActive, isMissing, note }] }
export const resolveServiceConsumables = (businessId, serviceIds) => {
  return api({
    url: `/api/business_B/${businessId}/products/consumables-resolve`,
    method: 'post',
    data: { serviceIds }
  })
}

// 成本報表相關API（需要後端新增）
export const getInventoryCostReport = (params) => {
  return api({
    url: `/api/store/inventory/cost-report`,
    method: 'get',
    params
  })
}

export const getInventoryProductCostAnalysis = (productId, params) => {
  return api({
    url: `/api/store/products/${productId}/cost-analysis`,
    method: 'get',
    params
  })
}

// 單一商品進出庫流水明細（進貨入庫 + 各類出庫 + 結存）
// 回傳 data: { currentStock, openingBalance, totalIn, totalOut, showCost, entries: [...] }
// params 可帶 startDate / endDate（YYYY-MM-DD）
export const getInventoryProductLedger = (productId, params) => {
  return api({
    url: `/api/store/inventory/products/${productId}/ledger`,
    method: 'get',
    params
  })
}

// 進貨紀錄查詢（需要後端新增）
export const getInventoryPurchaseRecords = (params) => {
  return api({
    url: `/api/store/inventory/purchase/records`,
    method: 'get',
    params
  })
}

// 更新進貨紀錄（需要後端新增）
export const updateInventoryPurchaseRecord = (purchaseId, data) => {
  return api({
    url: `/api/store/inventory/purchase/${purchaseId}`,
    method: 'put',
    data
  })
}

// 刪除進貨紀錄
// 後端會：(1) 回滾庫存 (2) 刪除記錄 (3) 依剩下最新一筆同步商品成本
// 回傳 data 含 restoredStocks / syncedCosts，前端可顯示變化提示
export const deleteInventoryPurchaseRecord = (purchaseId) => {
  return api({
    url: `/api/store/inventory/purchase/${purchaseId}`,
    method: 'delete'
  })
}
